import {
  BUTTON_HEIGHT,
  FONT_SIZE,
  MENU_COLORS,
  TEXT_SCALE_PROPS,
} from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<TEXT_SCALE_PROPS>`
  .min-width-100px {
    min-width: 100px;
  }
  .min-width-110px {
    min-width: 110px;
  }
  .min-width-60px {
    min-width: 60px;
  }
  .ant-btn:disabled {
    background: gray !important;
    color: white !important;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .ant-table-content {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-bottom: 40px;
  }
  .ant-table-row-expand-icon {
    display: none;
  }

  [data-row-key^="rowAsHeader_"] {
    /* css header */
    background-color: #eeeeee !important;
  }
  .ant-table-row {
    background-color: #f9f9f9;
  }

  td.ant-table-cell {
    border: 1px solid #fff;
    padding: 0px 16px !important;
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] + 5}px`} !important;
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    line-height: 1 !important;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ant-popconfirm .ok-btn,
  .ant-popover .ok-btn {
    background: ${MENU_COLORS.PRIMARY} !important;
    color: ${MENU_COLORS.TEXT_WHITE} !important;
    order: 1 !important;
    min-width: 80px !important;
  }
  .ant-input-number,
  .ant-form-item-control-input-content,
  .ant-form-item-control-input,
  .ant-input-number {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
    min-height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }
  .ant-table-row {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] + 5}px`} !important;
  }
`;
